import { Injectable, inject } from '@angular/core';

import { UserContextService } from '@hdms/shared/data-access';
import { EnvironmentService, FeatureToggleService } from '@hdms/shared/util-core';

import { FT_HDMS_DELIVERY_ADDRESS_MANAGEMENT } from './constants/feature-toggle.tokens';

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  private readonly environmentService = inject(EnvironmentService);
  private readonly userContext = inject(UserContextService);
  private readonly ftService = inject(FeatureToggleService);

  get isByDesign(): boolean {
    return this.environmentService.isByDesign;
  }

  get isAccountManager(): boolean {
    return this.userContext.isAccountManager;
  }

  get isDeliveryAddressManagementEnabled(): boolean {
    return this.ftService.getToggleById(FT_HDMS_DELIVERY_ADDRESS_MANAGEMENT);
  }
}
